<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { GpCard, GpTag } from '@gportal/uikit';
import { type BasicImage } from 'gpcore-grpc/gpcore/api/cloud/v1/image_pb';
import { faCheck, faCompactDisc } from '@fortawesome/pro-solid-svg-icons';

withDefaults(defineProps<{ image: BasicImage; isSelected?: boolean; isInstalled?: boolean }>(), {
  isSelected: false,
  isInstalled: false,
});

const emit = defineEmits<{ (e: 'imageSelected') }>();

const handleClick = () => {
  emit('imageSelected');
};
</script>

<template>
  <GpCard
    :active="isSelected"
    :enlarge-on-hover="false"
    :class="{ 'tw-cursor-pointer': !isSelected }"
    :content-title="image.name"
    :content-text="image.id"
    :aria-selected="isSelected"
    @click="handleClick"
  >
    <div class="tw-p-4">
      <p class="tw-mb-2 tw-text-xl">
        <FontAwesomeIcon :icon="faCompactDisc" class="tw-mr-4" />
        <span class="tw-font-bold">{{ image.name }}</span>
      </p>
      <span class="tw-text-sm tw-text-gp-rhino">{{ image.id }}</span>

      <div class="tw-mt-1 tw-flex tw-justify-end">
        <GpTag
          v-if="isInstalled"
          class="tw-uppercase"
          size="extra-small"
          tag-type="success"
          label="Installed"
          outline
          :icon="faCheck"
        />
      </div>
    </div>
  </GpCard>
</template>

<style scoped></style>
